const STORAGE_KEY = "fairlegal_client_id";

function fallbackId(): string {
    return `cid_${Math.random().toString(36).slice(2)}_${Date.now().toString(36)}`;
}

export function getClientId(): string {
    if (typeof window === "undefined") {
        return "server";
    }

    try {
        const existing = localStorage.getItem(STORAGE_KEY);
        if (existing) return existing;

        const id =
            typeof crypto !== "undefined" && "randomUUID" in crypto
                ? crypto.randomUUID()
                : fallbackId();

        localStorage.setItem(STORAGE_KEY, id);
        return id;
    } catch {
        return fallbackId();
    }
}